//import {takeLatest, delay, take, fork, all} from 'redux-saga/effects';
import {takeLatest, delay, take, cancelled, fork, all, takeEvery} from 'redux-saga/effects';
import {call, put, select, cancel} from 'redux-saga/effects';
import axios from 'axios';
import {find, isEmpty, startsWith} from 'lodash';
import qs from 'qs';
import {actionTypes, actions, selectors} from '../Redux/index';
import api, {mappings} from "../endpoint";

export const getRouteFromPathname = (pathname) => {
    // Find the best (most specific) match for the route by sorting mappings by route length descending.
    const sortedMappings = [...mappings].sort((a, b) => b.route.length - a.route.length);
    return find(sortedMappings, (m) => startsWith(pathname, m.route));
};

function* watchLocationChange(history) {
  while (true) {
    const location = yield call(waitForLocationChange, history);
 
    // console.log("ROUTE CHANGED →", location.pathname);
 
    yield put({
      type: 'CUSTOM_LOCATION_CHANGE',
      payload: { location }   // correct
    });
  }
}

function waitForLocationChange(history) {
  return new Promise(resolve => {
    const unlisten = history.listen((update) => {
      // ⚠️ important fix
      const location = update.location || update;
 
      unlisten();
      resolve(location);
    });
  });
}

function* routeReloadLoop(reloadTime, location) {
    try {
        // console.log('TIMER STARTED for', location.pathname);
        while (true) {
      yield delay(reloadTime);
 
      // console.log('AUTO RELOAD TRIGGERED');
 
      yield put(actions.Data.Reload.sagaReloadData({ location }));
    }
    } finally {
        if (yield cancelled()) {
            // console.log('TIMER CANCELLED for', location.pathname);
        }
    }
}

// function* reloadCurrencyPairData(action) {
//    const currencyPair = action.payload;
 
//    console.log(currencyPair);
 
//   yield put({
//    type: 'FETCH_CURRENCY_PAIR_DATA',
//    payload: currencyPair
// });
    
// }
 
function* fetchApiData(action) {
    let location = action.payload?.location;
    if (!location) {
        const routerState = yield select(selectors.Router.locationBeforeTransitions);
        location = routerState?.location || routerState; // Safely unwrap if it's nested
    }

    const path = location?.pathname;
    if (!path) return;

    const data = getRouteFromPathname(path);
    yield put({
        type: 'SET_LAST_ROUTE_DATA',
        payload: data
    }) ;

    if (!data) return;

//    let api = endpoints.api;


    let options = action.payload?.options || (data.optionsSelector ? yield select(data.optionsSelector) : {});

    // Fallback for homepage to ensure ccyPairs are always present
    if (path === '/' && (!options.ccyPairs || options.ccyPairs.length === 0)) {
        const homeDefaults = { ccyPairs: ['EUR_USD', 'EUR_JPY', 'EUR_CNH', 'EUR_SEK', 'EUR_GBP', 'EUR_PLN', 'EUR_SGD', 'EUR_CHF'] };
        options = Object.assign({}, homeDefaults, options);
    }
    const queryParams = Object.assign(
        {},
        !isEmpty(location.search) ? qs.parse(location.search.substring(1)) : {},
        options);
    const autoReload = action.type === actionTypes.Data.Reload.SAGA_RELOAD_DATA;

    if (path === '/') {
        // Determine breakpoint directly in the saga for reliability
        const currentBreakpoint = window.innerWidth <= 860 ? 'mobile' : 'desktop';
        Object.assign(queryParams, {
            client: currentBreakpoint
        });
    }

    const endpoint = data.getEndpoint(queryParams);

    try {
        yield put(data.action.start());

        const requestConfig = {
            method: 'get',
            baseURL: api,
            url: endpoint,
            withCredentials: false,
            responseType: 'json',
            crossDomain: true
        };

        if (queryParams) {
            Object.assign(requestConfig, {
                params: queryParams,
                // the default behavior for serializing parameter arrays is
                // ?foo[]=bar1&foo[]=bar2
                // but we want this
                // ?foo=bar1&foo=bar2
                paramsSerializer: function (params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            });
        }

        const response = yield call(axios, requestConfig);

        // enhance the result data with information about whether this results from auto-reload or user-reload
        Object.assign(response.data, {
            autoReload: autoReload,
            timestamp: new Date().toISOString()
        });

        yield put(data.action.success(response.data));

    } catch (e) {
        // console.error(e);
        yield put(data.action.error(e));
    }
}

export default function* getRouteData(args) {
  yield all([
    take('SYSTEM_READY'),
    take('LOCAL_STORAGE_READY')
  ]);
 
    // Handle manual reloads by dispatching a location change,
    // which is handled by the takeLatest below. This calls fetchApiData directly to avoid race conditions.
    yield takeEvery(actionTypes.Data.Reload.SAGA_RELOAD_DATA, fetchApiData);

    // yield fork(routeReloadLoop); // This was the source of the bug
    yield fork(watchLocationChange, args.history);

    let lastPathname = null;

    // This single takeLatest handles all logic for route changes.
    yield takeLatest('CUSTOM_LOCATION_CHANGE', function* (action) {
        const { location } = action.payload;
        const { pathname } = location;
        const currentRoute = location.pathname + location.search;
        // console.log("CUSTOM_LOCATION_CHANGE →", pathname);

        // Only fetch if the path has actually changed. Manual reloads are handled by a separate takeEvery.
        if (currentRoute !== lastPathname) {
            lastPathname = currentRoute;
            yield call(fetchApiData, action);
            const data = getRouteFromPathname(pathname);
            if (data?.reloadTime) {
                yield fork(routeReloadLoop, data.reloadTime, location);
            }
        }
    });

    // yield takeLatest(
    //     actionTypes.SAGA_RELOAD_DATA_CURRENCY_PAIR,
    //     reloadCurrencyPairData
    // );

    // Dispatch an action to trigger the initial data fetch via takeLatest.
    // This ensures a single, consistent path for all data loading on route changes.
    yield put({
        type: 'CUSTOM_LOCATION_CHANGE',
        payload: { location: args.history.location }
    });
}
